import React from 'react';
import { FormattedMessage } from 'react-intl';

// temporary work-around (see https://github.com/yahoo/babel-plugin-react-intl/issues/119)
function FormattedMessageConditionnal({ children, ...props }) {
  return children ? <FormattedMessage {...props}>{children}</FormattedMessage> : <FormattedMessage {...props} />;
}

export default FormattedMessageConditionnal;
